<template>
  <div class="main">
    <report-top> </report-top>
    <div id="formTable">
      <div class="formTableItem">
        <p class="label">车牌号</p>
        <div style="width: 120px">
          <selectCar
            :name="searchItem.carNo"
            @update:name="searchItem.carNo = $event"
            :deviceNo="searchItem.deviceNo"
            @update:deviceNo="searchItem.deviceNo = $event"
            clearable
            placement='left'
            filterGroup="车辆"
          ></selectCar>
        </div>
      </div>
      <div class="formTableItem">
        <p class="label">时间范围</p>
        <start-end ref="startEnd" timeModel="0" :datetime='true'></start-end>
      </div>
      <div class="formTableItem">
        <Button @click="chaxun" type="primary" size="small" class="chaxun"
          >立即查询</Button
        >
        <Button @click="$refs.oilList.open()" size="small" class="chaxun"
          >查看报表</Button
        >
      </div>
    </div>
    <div id="oil-wrap">
      <oil-draw ref="oil"></oil-draw>
    </div>
    <oil-list ref="oilList"></oil-list>
  </div>
</template>
<script>
import axios from "axios";
import oilDraw from "./draw.vue";
import oilList from "./list.vue"

export default {
  components: {oilDraw,oilList},
  data() {
    return {
      searchItem: {
        deviceNo: "",
        carNo: "",
        returnCoord: 2, //返回坐标系（1-WGS84，2-GCJ-02，3-BD-09）,可用值:1,2,3
        endTime: "",
        startTime: "",
      },
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: axios.lbs + "/oil/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        var data = res.data.data.dataList;
        this.$refs.oilList.reachData(data);
        if (data.length == 0) {
          this.$Message.error("暂无数据");
        }
        this.total = res.data.data.total;

       
        var list = [];
        var waveList = [];
        for (let i = 0; i < data.length; i++) {
          data[i].gpsTime = this.utils.time(data[i].gpsTime);
          var obj = {
            value: [
              data[i].gpsTime,
              data[i].oilLiters,
              data[i].accStatus == 0 ? "关" : "开",
              data[i].speed,
              data[i].oil,
            ],
          };
          list.push(obj);
          /* if (data[i].ocFlag != 0) {
            var ddd = [
              data[i].gpsTime,
              data[i].oilLiters,
              data[i].ocOilVolume,
              data[i].ocFlag == 1 ? "加油" : "放油",
            ];
            waveList.push(ddd);
          } */
        }
        this.$refs.oil.reData(list, waveList);
      });
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    chaxun() {
      this.searchItem.startTime = this.$refs.startEnd.getTimeObj().start;
      this.searchItem.endTime = this.$refs.startEnd.getTimeObj().end;
      this.getList();
    },
    search() {
      console.log(this.keyWork);
      this.reset();
      this.getList();
    },
    reset() {},
  },

};
</script>
<style lang="">
#oil_wrap {
  width: 100%;
  height: 500px;
}
</style>


// WEBPACK FOOTER //
// src/components/water/index.vue